import * as React from 'react'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import BoxListInputLinkItem from 'modules/dashboard/widgets/CompanyLinks/components/BoxListInputLinkItem'
import type { CompanyLinkFormValue } from 'modules/dashboard/widgets/CompanyLinks/forms'

interface Props {
  item: CompanyLinkFormValue
  onDelete: (index: number) => void
  index: number
  showPopoverOptions?: boolean
}

const CompanyLinksItem = ({ item, onDelete, index, showPopoverOptions }: Props) => {
  const options = [
    {
      title: i18n.t('common.destroy'),
      onClick: () => onDelete(index),
      danger: true,
    },
  ]

  return (
    <BoxListInputLinkItem
      item={item}
      index={index}
      popoverOptions={showPopoverOptions ? options : []}
      popoverDisablePortal
      sortable
    />
  )
}

export default observer(CompanyLinksItem)
